import { render, staticRenderFns } from "./FabricTypeIndex.vue?vue&type=template&id=221bac16&scoped=true&"
import script from "./FabricTypeIndex.vue?vue&type=script&lang=js&"
export * from "./FabricTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221bac16",
  null
  
)

export default component.exports